// extracted by mini-css-extract-plugin
export var attachmentContainer = "_l8-0";
export var fileList = "_l8-2";
export var removeFileButton = "_l8-1";